<div class="cej-v2-form-contact-modal">
  <button
    *ngIf="(isMobile$ | async) === false"
    type="button"
    class="btn-clean cej-v2-form-contact-modal__cross"
    aria-label="Recommencer le formulaire"
    (click)="resetForm()"
  >
    <mat-icon svgIcon="cross" aria-label="Cross icon"></mat-icon>
  </button>
  <section role="region" *ngIf="(loading$ | async) === false">
    <h1 role="heading" class="cej-v2-form-contact-modal__title">
      <ng-container *ngIf="(isMobile$ | async) === false">
        <span class="line-break">Vous pouvez bénéficier d&apos;un accompagnement</span>
        répondant à vos besoins auprès de votre Mission Locale
      </ng-container>
      <ng-container *ngIf="(isMobile$ | async) === true">
        Vous pouvez bénéficier d&apos;un accompagnement répondant à vos besoins auprès de votre Mission Locale
      </ng-container>
    </h1>
  </section>

  <ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
    <form
      id="contact-form"
      class="cej-v2-form-contact-modal__form"
      [formGroup]="form"
      appInvalidControlScroll
      (ngSubmit)="submitForm()"
    >
      <mat-form-field
        class="cej-v2-form-contact-modal__form__firstName"
        [style.-ms-grid-column]="1"
        [style.-ms-grid-row]="1"
      >
        <mat-label>Prénom</mat-label>
        <input type="text" formControlName="firstName" autocomplete="given-name" matInput />
        <mat-error *ngIf="firstName?.errors?.required || firstName.errors?.whitespace">Le prénom est requis</mat-error>
      </mat-form-field>

      <mat-form-field
        class="cej-v2-form-contact-modal__form__lastName"
        [style.-ms-grid-column]="3"
        [style.-ms-grid-row]="1"
      >
        <mat-label>Nom</mat-label>
        <input type="text" formControlName="lastName" autocomplete="family-name" matInput />
        <mat-error *ngIf="lastName?.errors?.required || lastName.errors?.whitespace">Le nom est requis</mat-error>
      </mat-form-field>

      <mat-form-field class="cej-v2-form-contact-modal__form__age">
        <mat-label>Âge</mat-label>
        <mat-select
          formControlName="age"
          #ageSelect="matSelect"
          aria-label="Contact mission locale, liste déroulante réduite pour sélectionner l'âge"
        >
          <mat-option *ngFor="let age of ages; trackBy: trackByAge" [value]="age">{{ age }} ans</mat-option>
        </mat-select>
        <mat-error *ngIf="age?.errors?.required || age?.errors?.whitespace">L&apos;âge est requis</mat-error>
      </mat-form-field>

      <app-zipcode-input-pole-emploi
        formControlName="city"
        class="cej-v2-cej-v2-form-contact-modal__form--zipcode"
        [fieldConfig]="zipCodeFieldConfig"
      ></app-zipcode-input-pole-emploi>

      <mat-form-field class="cej-v2-form-contact-modal__form__mail cej-v2-form-contact-modal__form__mail--home">
        <mat-label>Adresse e-mail</mat-label>
        <input type="text" formControlName="mail" autocomplete="email" matInput />
        <mat-error *ngIf="mail?.errors?.required">L&apos;adresse email est requise</mat-error>
        <mat-error *ngIf="mail?.errors?.email">L&apos;adresse email est invalide</mat-error>
      </mat-form-field>

      <mat-form-field class="cej-v2-form-contact-modal__form__phone">
        <mat-label>Téléphone</mat-label>
        <input type="text" formControlName="phone" autocomplete="tel-national" matInput />
        <mat-error *ngIf="phone?.errors?.required">Le numéro de téléphone est requis</mat-error>
        <mat-error *ngIf="phone?.errors?.phone">Le numéro de téléphone est incorrect</mat-error>
      </mat-form-field>
    </form>
  </ng-container>

  <button
    *ngIf="(loading$ | async) === false"
    class="btn-clean btn cej-v2-form-contact-modal__btn"
    type="submit"
    form="contact-form"
  >
    Je souhaite être rappelé
  </button>

  <button
    *ngIf="(isMobile$ | async) === true"
    type="button"
    class="btn-clean cej-v2-form-contact-modal__mobile-close-btn"
    (click)="resetForm()"
  >
    Fermer
  </button>

  <ng-container *ngIf="(loading$ | async) === false">
    <app-form-rgpd-info>
      En cliquant sur "Je souhaite être rappelé", j&apos;accepte que mes données soient transférées à la mission locale
      de la zone géographique dans laquelle je réside en vue d&apos;être rappelé.
    </app-form-rgpd-info>
  </ng-container>
</div>

<ng-template #loadingTemplate>
  <div class="loader-container">
    <app-checkmark-loader
      [styleCss]="styleCssCheckmarkLoader | async"
      class="loader"
      [loading]="loadingLoader$ | async"
    >
      <ng-container *ngIf="(loadingLoader$ | async) === true">Envoi en cours</ng-container>
      <ng-container *ngIf="(loadingLoader$ | async) === false">
        Votre demande a bien été prise en compte&nbsp;! Notre équipe prendra contact avec vous rapidement.
      </ng-container>
    </app-checkmark-loader>

    <ng-container>
      <h2 role="heading" class="loader__title">
        <ng-container *ngIf="(loadingLoader$ | async) === true">Envoi en cours</ng-container>
        <ng-container *ngIf="(loadingLoader$ | async) === false"
          >Votre demande a bien été prise en compte&nbsp;!</ng-container
        >
      </h2>
      <p *ngIf="(loadingLoader$ | async) === false" class="loader__subtitle">
        Notre équipe prendra contact avec vous rapidement.
      </p>
    </ng-container>
  </div>
</ng-template>
